<template>

  <div :class="$forms.stepperContainer">
    <app-overview title="Assets Overview">

      <template v-slot:overviewImage>
        <img src="@/assets/img/ic_cover_asset.png" alt="Assets">
      </template>

      <template v-slot:overviewContent>

        <h6>Please fill out the next series of questions as accurately as possible: </h6>

        <div :class="$style.assets">
          <ul :class="$style.assetsOverviewList">
            <li>Refer to previous years tax returns and to your pay stub(s)</li>
            <li>Credit card(s) statements</li>
            <li>Mortgage statements</li>
            <li>Automobile loan(s)</li>
            <li>Bank account(s) statements</li>
            <li>Insurance(s) payments.</li>
          </ul>
        </div>

        <p>
          For complete list of supporting documents that may be required
          <a href="https://eztx.com/supporting-documents/"
             target="_blank"
             rel="noopener">click here</a>
        </p>

        <p>The software will always calculate the lowest possible amount in favor of the taxpayer.
          For this reason, we always recommend that taxpayers fill out all the required fields
          truthfully and not try to “Beat the System" by fudging numbers. </p>

        <app-info-block>
          Since the taxpayer will almost always be asked for proof of income and expenses,
          it is not only best to be totally honest, but you will sign IRS forms under penalty of
          perjury at the end of the program.
        </app-info-block>

        <p :class="$style.overviewInfo">
          Our legal and our technical teams have optimized the software programs to the taxpayer's
          maximum benefit while staying within the letter of National IRS Tax Rules.
        </p>

      </template>

    </app-overview>
  </div>

</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'checkAssets',
    ]),
  },
  mounted() {
    this.checkAssets();
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style src="@/app/assets/styles/assets.scss" lang="scss" module />
